import React from 'react';
import { PageLayout } from 'shared/ui';
import { BusinessRegistrationForm, Header } from 'widgets';
import { OnboardingStepIndicator } from 'features/onboarding';

export const BusinessRegistrationPage: React.FC = () => {
  return (
    <>
      <OnboardingStepIndicator />
      <PageLayout>
        <Header />
        <BusinessRegistrationForm></BusinessRegistrationForm>
      </PageLayout>
    </>
  );
};
